<template>
  <form class="form-inline ml-auto row no-gutters search-form">
    <div class="document col-1 pl-0">
      <icon name="file-text-o" scale="1.25"></icon>
    </div>
    <input v-model="searchRequest" class="form-control col" type="text" placeholder="Search Title, Abstract, Author, Keyword">
    <div class="button-wrapper col-1 p-0">
      <router-link :to="{ name: 'searchResults', params: { request: searchRequest }}"><b-button class="button-secondary button-square my-2 my-sm-0" :disabled="!searchRequest" type="submit">
        <div class="icon icon-search"></div>
      </b-button></router-link>
    </div>
  </form>
</template>

<script>
  export default {
    name: 'search-field',
    data () {
      return {
        searchRequest: ''
      }
    }
  }

</script>

<style lang="scss" scoped>
  .form-inline.search-form {
    border-bottom: 1px solid $search-input-border;

  .form-control {
    border: none;
    border-radius: 0;
    font-family: 'Merriweather', serif;
    font-weight: 300;
    font-size: 14px;
    width: 270px;
    padding-bottom: 0px;
    font-style: italic;

  &:focus {
     border-color: $search-input-border;
   }

  &::-webkit-input-placeholder { /* Chrome/Opera/Safari */
     color: $search-placeholder;
   }

  &::-moz-placeholder { /* Firefox 19+ */
     color: $search-placeholder;
   }

  &:-ms-input-placeholder { /* IE 10+ */
     color: $search-placeholder;
   }

  &:-moz-placeholder { /* Firefox 18- */
     color: $search-placeholder;
   }

  }

  .document, .form-control, .button-wrapper {
    height: 32px;
  }

  .document {
    color: $primary-color;
    padding-top: 7px;
  }

  .button-wrapper {
    padding-top: 2px;
    margin-left: 5px;
  button {
    background-color: $secondary-color;
    color: $white;
    border: none;
    padding: 0;
    line-height: 90%;
    height: 25px;
    width: 25px;
  }
  }
  }

</style>



// WEBPACK FOOTER //
// SearchFieldComponent.vue?75405f24